module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/faq-components/faq-list/faq-list.component.scss
// module id = ./src/app/faq-components/faq-list/faq-list.component.scss
// module chunks = main